import { BaseService } from "./base.service";
import { Notification } from "@/types/notification.type";

export class NotificationService extends BaseService {
  constructor() {
    super("");
  }

  async getInfoNotifications(): Promise<Notification[]> {
    return this.get<Notification[]>("/notifications/info");
  }

  async markAsRead(id: string): Promise<Notification> {
    return this.post<Notification>(`/notifications/${id}/read`, {});
  }

  async getActionNotifications(): Promise<Notification[]> {
    return this.get<Notification[]>("/notifications/actions");
  }

  async handleAccept(id: string): Promise<Notification> {
    return this.post<Notification>(`/notifications/${id}/accept`, {});
  }

  async handleDecline(id: string): Promise<Notification> {
    return this.post<Notification>(`/notifications/${id}/decline`, {});
  }
}

export const notificationService = new NotificationService();
